import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class ReportConstructionPOInfo extends BaseBus {
    constructor(dataObj: ReportConstructionPOInfo = null) {
        super(dataObj);
        this.dateExpected = DateFunctions.getDate(dataObj.dateExpected);
        this.dateEntered = DateFunctions.getDate(dataObj.dateEntered);
        this.invoiceDate = DateFunctions.getDate(dataObj.invoiceDate);
    }
    supplierName: string;
    orderNumber: string;
    dispatchNumber: string;
    dateExpected: Date;
    poTotal: number;
    sumAmountBilled: number;
    sumAmtPaid: number;
    notYetPaid: number;
    unbilled: number;
    isSubContract: boolean;
    orderStatusId: any;
    buyerPersonId: any;
    customerName: string;
    locationName: string;
    customerId: any;
    dateEntered: Date;
    accountClassId: any; //dispatch
    orderId: any;
    dispatchId: any;
    blanketAmount: number;//o.BlanketAmount + o.ChgOrdBlanketAmount
    relatedJobTypeId: any;
    supplierLocationName: string;
    co: number;
    refNbr: string;
    regionName: string;
    accountClassName: string;
    totalReceivedDollars: number;
    invReceivedUnbilled: number;
    nonPartInvReceivedUnbilled: number;
    unbilledBillingCodes: number;
    faAccount: string;
    orderStatusName: string;
    dispatchStatusName: string;
    invoiceNumber: string;
    invoiceDate: Date;
    buyerName: string;
    relatedJobType: string;
    divisionName: string;
    dateEnteredDays: number;
    isConstruction: boolean;
    masterJobId: any;
    isContract: boolean;
    techCreated: boolean;
    showDetails: boolean;
    orderBills: any[];
    needsPayment: boolean;
    hasApToCut: boolean;
    hasApproved: boolean;
    termName: string;
    orderNotes: string;
    billEntered: Date;
}
